export function download(url: string, filename: string) {
  fetch(url).then(function (t) {
    return t.blob().then((b) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.setAttribute('download', filename);
      a.click();
    });
  });
}
